/** Palette key for `theme.vars.palette[color]` (success / error / warning) or `grey` for the neutral scale. */
export type JobStatusPaletteColor = 'success' | 'grey' | 'error' | 'warning';

export const statusOptions: {
  label: string;
  value: string;
  color: JobStatusPaletteColor;
  alertColor: string;
  description: string;
}[] = [
  {
    label: 'Active',
    value: 'OpenForPublic',
    color: 'success',
    alertColor: 'success.lighter',
    description: 'This job post is **Live**. Candidates can now view and apply in real-time.',
  },
  {
    label: 'Paused',
    value: 'Paused',
    color: 'grey',
    alertColor: 'grey.200',
    description:
      'This job post is **Paused**. It’s hidden from candidates but can be resumed anytime.',
  },
  {
    label: 'Closed',
    value: 'Closed',
    color: 'error',
    alertColor: 'error.lighter',
    description: 'This job post is **Closed**. It’s no longer accepting applications and is archived.',
  },
  {
    label: 'Draft',
    value: 'Draft',
    color: 'warning',
    alertColor: 'warning.lighter',
    description:
      'This job post is currently in **Draft**. Complete the details and make the job “Active” to go live.',
  },
];

export const jobModeOptions = [
  { label: 'Remote', value: 'Remote' },
  { label: 'On-site', value: 'On-site' },
  { label: 'Hybrid', value: 'Hybrid' },
];

export const jobTypeOptions = [
  { label: 'Full-time', value: 'Full-Time' },
  { label: 'Part-time', value: 'Part-Time' },
  { label: 'Contract', value: 'Contract' },
  { label: 'Internship', value: 'Internship' },
  { label: 'Temporary', value: 'Temporary' },
  { label: 'Seasonal', value: 'Seasonal' },
  { label: 'Volunteer', value: 'Volunteer' },
];

export interface Skill {
  id: number | string;
  name: string;
  onDelete?: (id: number | string) => void;
}

export interface EditableField {
  value: string;
  editable: boolean;
  tempValue: string;
}

export interface JobDetails {
  Experience: EditableField;
  Salary: EditableField;
  Department: EditableField;
}

export interface JobEditorProps {
  updateJobDetails: (jobId: string, payload: any, callback: (data: any, success: boolean) => void) => void;
  updateLoading: boolean;
  openAiAssistantModal: (props: { oldContentHtml: string, jobId: string, oldContentText: string, onApply: (htmlData: string, textData: string) => void }) => void;
}

export interface Perk {
  key: string;
  checked: boolean;
}

export type Value = string;

export interface RoleDetails {
  Title: {
    value: string;
    editable: boolean;
    tempValue: string;
  };
  LocationCountry: {
    value: string;
    editable: boolean;
    tempValue: string;
  };
  LocationCity: {
    value: string;
    editable: boolean;
    tempValue: string;
  };
  JobMode: {
    value: string;
    editable: boolean;
    tempValue: string;
  };
  JobType: {
    value: string;
    editable: boolean;
    tempValue: string;
  };
}

export interface JobsPageProps {
  data: any;
  fetchJobs: () => void;
  jobs: any[];
  loading: boolean;
  openJobShareModal: (jobCardProps: any) => void;
  duplicateJob: (jobId: string, callback: (data: any, success: boolean) => void) => void;
}

export interface FilterOption {
  ai_assigned: boolean;
  needs_attention: boolean;
  interview_scheduled: boolean;
}

export interface AiAssistantModalProps {
  getAiEnhancement: (jobId: string, jobDescription: string) => void;
  newContent: any;
  loading: boolean;
}

export interface EditorContent {
  tempHtml: string;
  html: string;
}

export interface EditorText {
  tempText: string;
  text: string;
}

